<template>
	<div class="tab" data-name="SupplementaryInfo" data-type="table">
		<h3>فرم معرف</h3>
		<h6>[اسامي سه نفر از کساني را که با شما نسبت خویشاوندي ندارند بعنوان معرف ذکر کنيد]</h6>
		<table class="table table-bordered">
			<thead>
				<tr>
					<td>نام و نام خانوادگی</td>
					<td>محل اشتغال</td>
					<td>سمت</td>
					<td>نوع اشنایی</td>
					<td>ادرس</td>
					<td>تلفن</td>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>
						<input type="text" data-row="0" class="form-control" data-name="fullName" />
					</td>
					<td>
						<input type="text" data-row="0" class="form-control" data-name="placeOfWork" />
					</td>
					<td>
						<input type="text" data-row="0" class="form-control" data-name="position" />
					</td>
					<td>
						<input type="text" data-row="0" class="form-control" data-name="acquaintance" />
					</td>
					<td>
						<input type="text" data-row="0" class="form-control" data-name="aaddress" />
					</td>
					<td>
						<input type="text" data-row="0" class="form-control" data-name="phoneNumber" />
					</td>
				</tr>
				<tr>
					<td>
						<input type="text" data-row="1" class="form-control" data-name="fullName" />
					</td>
					<td>
						<input type="text" data-row="1" class="form-control" data-name="placeOfWork" />
					</td>
					<td>
						<input type="text" data-row="1" class="form-control" data-name="position" />
					</td>
					<td>
						<input type="text" data-row="1" class="form-control" data-name="acquaintance" />
					</td>
					<td>
						<input type="text" data-row="1" class="form-control" data-name="aaddress" />
					</td>
					<td>
						<input type="text" data-row="1" class="form-control" data-name="phoneNumber" />
					</td>
				</tr>
				<tr>
					<td>
						<input type="text" data-row="2" class="form-control" data-name="fullName" />
					</td>
					<td>
						<input type="text" data-row="2" class="form-control" data-name="placeOfWork" />
					</td>
					<td>
						<input type="text" data-row="2" class="form-control" data-name="position" />
					</td>
					<td>
						<input type="text" data-row="2" class="form-control" data-name="acquaintance" />
					</td>
					<td>
						<input type="text" data-row="2" class="form-control" data-name="aaddress" />
					</td>
					<td>
						<input type="text" data-row="2" class="form-control" data-name="phoneNumber" />
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>
<script>
	export default {
		emits: ["change"],
		props: {
			init: {
				type: Function,
			},
			contract: {
				type: Object,
			},
		},

		change(e)
		{
			this.$emit("change", e.target);
		},

		mounted()
		{
			this.init();
		},

	};
</script>
